import Head from 'next/head'
import React from 'react'

import { stringifyJsonLd } from '@/lib/json-ld'

interface StructuredDataProps {
  schema: Record<string, unknown>
}

function StructuredData({ schema }: StructuredDataProps) {
  return (
    <Head>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: stringifyJsonLd(schema) }} />
    </Head>
  )
}

export default StructuredData
